import documentsList from '@/store/modules/documents/documents-list'
import documentCreate from '@/store/modules/documents/document-create'
import documentEdit from '@/store/modules/documents/document-edit'
import documentDelete from '@/store/modules/documents/document-delete'

export default {
  documentsList,
  documentCreate,
  documentEdit,
  documentDelete,
}
